import { ClaimRequest } from '@bybeam/platform-types';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';
import useClaim from '@platform-ui/claim/hooks/useClaim.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { ReactNode } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

function Wrapper({ children }: { children: ReactNode }): JSX.Element {
  const { fulfillment, method } = useClaim<ClaimRequest>();

  if (!method || !fulfillment) {
    const redirectRoute = fulfillment
      ? makeRoute(ClaimRoutes.PAYMENT_METHOD, { fulfillmentId: fulfillment.id })
      : ApplicantRoutes.APPLICATION_PORTAL;

    return <Redirect to={redirectRoute} />;
  }
  return <>{children}</>;
}

export default function ClaimRoute(props: RouteProps): JSX.Element {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(renderProps): ReactNode => (
        <Wrapper {...renderProps}>
          <Component {...renderProps} />
        </Wrapper>
      )}
    />
  );
}
